import {Operators} from "../model/Operators";

export const AttributeType = {
  user: "user",
};

export const InputType = {
  SingleValuedFieldInBackend: {
    name:"SingleValuedFieldInBackend",
    allowedOperators:[Operators.comparisonSTRING_IN,Operators.comparisonEQ]
  },
  MultiValuedFieldInBackend:{
    name:"MultiValuedFieldInBackend",
    allowedOperators:[Operators.comparisonARRAY_CONTAINS]
  }
};
